import React from 'react';

const Body = ({ children }) => (
    
    <div className="p-2 dark:text-white text-base bg-gray-100 dark:bg-gray-700 border rounded">
        {children}
    </div>
)

export default Body